import Loading from 'app/atoms/Loading';
import { Suspense, useEffect, useState } from 'react';
import './LiveLikeALocal.scss';
import LiveLikeALocalPropertyCarousel from './LiveLikeALocalPropertyCarousel/LiveLikeALocalPropertyCarousel';
import LiveLikeALocalImage from './LiveLikeALocalImage/LiveLikeALocalImage';
import { useParams } from 'react-router';
import { sanityClient } from '../../../sanity.io/config';
import SanityHeroSection from '../../atoms/Sanity/SanityHeroSection/SanityHeroSection';
import SanityHeader from '../../atoms/Sanity/SanityHeader/SanityHeader';
import { LiveLikeALocalProps } from './LiveLikeALocal.types';
import SanitySubHeader from '../../atoms/Sanity/SanitySubHeader/SanitySubHeader';
import SanityBody from '../../atoms/Sanity/SanityBody/SanityBody';
import Copyright from '../../molecules/Footer/Copyright';

function LiveLikeALocal() {
  const { journal } = useParams<{ journal: string }>();
  const [data, setData] = useState<LiveLikeALocalProps>();

  useEffect(() => {
    sanityClient.fetch(`*[ _type== "journal" && slug.current == "${journal.toLowerCase()}"]{ ..., city->, author-> }`).then(response => {
      if (response && response[0]) {
        setData(response[0]);
      }
    });
  }, []);

  return (
    <Suspense
      fallback={
        <div>
          <Loading force={true} />
        </div>
      }
    >
      {data && (
        <>
          <SanityHeroSection heroImageUrl={data.heroImage.asset._ref} />
          <section className="d-flex">
            <div className="london-with-dogs-container col-12 col-sm-8">
              <SanityHeader title={data.title} author={data.author.name} date={data._createdAt} />
              <SanitySubHeader subHeader={data.header} />
              <SanityBody body={data.body} />
              <LiveLikeALocalImage sidebarImageUrl={data.sideBarImage.asset._ref} innerClass={'d-block d-sm-none'} />
              <div className="col-lg-12 col-md-12 copy-right p-0">
                <Copyright />
              </div>
            </div>
            <LiveLikeALocalImage sidebarImageUrl={data.sideBarImage.asset._ref} innerClass={'d-none d-sm-block'} />
          </section>
          <LiveLikeALocalPropertyCarousel
            title="Puppy Palaces"
            subtitle={`Check out some of our most dog friendly ${data.city.name} homes`}
            city={data.city.name}
          />
        </>
      )}
    </Suspense>
  );
}
export default LiveLikeALocal;
